import SwiperSlider from '../base';

const selectors = {
  sliderEl: '[data-comp-general-slider]',
  pagination: '[data-general-slider="pagination"]',
};

const swiperOptions = {
  loop: true,
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween: 13,
  pagination: {
    el: selectors.pagination,
    clickable: true,
  },
  breakpoints: {
    768: {
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
    },
  },
};

export default class SectionGeneralSlider extends SwiperSlider {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.generalSlider = new this.Swiper(
      this.$container,
      swiperOptions,
    );
  }
}
